<template>
  <!-- *RPD MHOR  Appv 0.91
* Copyright (c) 2025, Blue Cover Six LLC . ?John Molt All rights reserved.
Code licensed under contract To Reno Police Department / City of Reno, in perpetuity -->
  <div style="width: 94%; margin-top: 60px; margin-left: 3%; margin-right: 3%">
    <auth2></auth2>
    <template>
      <div v-if="showme == 'search'">
        <p>
          Please enter a name or an address. Only one will be searched, name
          first. In both fields, partial matches are allowed and are
          case-insensitive. Example: 'Bert' will match 'Robert Smith'.
        </p>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            color="white"
            v-model="sterm.lname"
            :counter="120"
            maxlength="120"
            label="Last Name"
            required
          ></v-text-field>
          <v-text-field
            color="white"
            v-model="sterm.address"
            :counter="120"
            maxlength="120"
            label="Address"
            required
          ></v-text-field>
          <v-btn @click="search_one"> Search </v-btn>
        </v-form>
      </div>
    </template>

    <!-- search results -->
    <div id="all_cards" v-if="showme == 'results'">
      <v-btn @click="backtosearch">Back To Search</v-btn>
      <h4 style="margin-top: 15px">List of Results</h4>
      <v-card
        v-for="reg in srch_results"
        :key="reg.registrationId"
        dark
        class="ma-4 grey darken-3"
        elevation="3"
      >
        <v-card-title>{{ reg.lname }}, {{ reg.fname }} </v-card-title>

        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12" md="4"
                ><label>Reference #</label
                ><output>{{ reg.registrationId | prepend100 }}</output></v-col
              >
            </v-row>
            <v-row dense>
              <v-col cols="12" md="4"
                ><label style="font-size: 18px; color: aqua">Weapons:</label
                ><output style="font-size: 18px; color: aqua">{{
                  reg.weapons | blankanswer
                }}</output></v-col
              >
              <v-col cols="12" md="12" v-if="reg.violence.length > 0"
                ><label style="font-size: 18px; color: "
                  >History of aggression or violence?:</label
                ><output style="font-size: 16px; color: ">{{
                  reg.violence
                }}</output></v-col
              >
              <v-col cols="12" md="12" v-if="reg.triggers.length > 0"
                ><label style="font-size: 18px; color: ">Known Triggers:</label
                ><output style="font-size: 16px; color: ">{{
                  reg.triggers | spaceAfterComma
                }}</output></v-col
              >
            </v-row>
            <hr style="margin-bottom: 10px" />
            <v-row dense
              ><v-col cols="12" md="4"
                ><label>Phone</label><output>{{ reg.phone }}</output></v-col
              >
              <v-col cols="12" md="4" class="pr-2"
                ><label>Address</label><output>{{ reg.address }}</output></v-col
              >
              <v-col cols="12" md="4"
                ><label>Email</label><output>{{ reg.email }}</output></v-col
              >
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-row dense
            ><v-col cols="12" md="2">
              <v-btn class="btn-size" dark @click="view(reg)"
                ><v-icon class="mr-1">$eye</v-icon>View</v-btn
              >
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </div>
    <!-- main view -->
<template>
  <v-form
    ref="form"
    dark
    v-model="valid"
    lazy-validation
    v-if="showme == 'reg'"
  >
    <v-btn @click="backtosearch" style="margin-top: 15px"
      >Back To Search</v-btn
    >
    <br />
    <v-btn @click="backtoresults" style="margin-top: 15px"
      >Back To Results</v-btn
    >
    <h4 style="margin-top: 15px">Registration</h4>
    <v-container fluid id="form-container">
      <v-row dense>
        <v-col cols="12" md="6">
          <v-text-field
            color="white"
            dark
            maxlength="60"
            v-model="reg.fname"
            :counter="60"
            label="First Name"
            required
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            color="white"
            dark
            maxlength="60"
            v-model="reg.lname"
            :counter="60"
            label="Last Name"
            required
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" md="6">
          <v-text-field
            color="white"
            dark
            maxlength="120"
            v-model="reg.dob"
            :counter="120"
            label="DOB"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            color="white"
            dark
            maxlength="120"
            v-model="reg.email"
            :counter="120"
            label="Email"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" md="6">
          <v-text-field
            v-mask="'###-###-####'"
            color="white"
            dark
            maxlength="12"
            v-model="reg.phone"
            :counter="12"
            label="Phone"
            placeholder="###-###-####"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            color="white"
            dark
            maxlength="120"
            v-model="reg.address"
            :counter="120"
            label="Address"
            required
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- *************************** row 4 -->
      <v-row dense>
        <v-col cols="12" md="6">
          <v-text-field
            color="white"
            dark
            maxlength="60"
            v-model="reg.prim_lang"
            :counter="60"
            label="Primary language"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            color="white"
            dark
            maxlength="60"
            v-model="reg.gender"
            label="Gender"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- Emergency Contact information: Name, Relationship, Phone # -->
      <h4 class="mt-5">Emergency Contact Information (ECI)</h4>
      <v-row dense>
        <v-col cols="12" md="6">
          <v-text-field
            color="white"
            dark
            maxlength="120"
            v-model="reg.eci_name"
            :counter="120"
            label="ECI Name"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-select
            dark
            color="white"
            attach
            v-model="reg.eci_rltnshp"
            :items="[
              'Husband',
              'Wife',
              'Guardian',
              'Grandparent',
              'Sibling',
              'Caregiver',
              'Friend',
            ]"
            label="Relationship"
            readonly
            disabled
          ></v-select>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            v-mask="'###-###-####'"
            color="white"
            dark
            maxlength="12"
            v-model="reg.eci_phone"
            :counter="12"
            label="Phone"
            placeholder="###-###-####"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense class="mt-5">
        <v-col cols="12" md="12">
          <v-select
            dark
            color="white"
            attach
            v-model="reg.weapons"
            :items="['No', 'Yes']"
            label="Are there any weapons in the home?"
            readonly
            disabled
          ></v-select>
        </v-col>
      </v-row>
      <!-- Mental Health ************************** -->

      <v-row dense class="mt-3">
        <v-col cols="12" md="12">
          <label>Mental Health</label>
          <v-textarea
            color="white"
            v-model="reg.mental_health"
            outlined
            auto-grow
            :rows="3"
            :counter="2000"
            :maxlength="2000"
            readonly
          />
        </v-col>
      </v-row>

      <v-row dense class="mt-3">
        <v-col cols="12" md="12">
          <label>Substance Use</label>
          <v-textarea
            color="white"
            v-model="reg.substance"
            outlined
            auto-grow
            :rows="3"
            :counter="2000"
            :maxlength="2000"
            readonly
          />
        </v-col>
      </v-row>
      <v-row dense class="mt-3">
        <v-col cols="12" md="12">
          <label>Medications</label>
          <v-textarea
            color="white"
            v-model="reg.medications"
            outlined
            auto-grow
            :rows="3"
            :counter="2000"
            :maxlength="2000"
            readonly
          />
        </v-col>
      </v-row>
      <v-row dense class="mt-3">
        <v-col cols="12" md="12">
          <label>
            History of Hospitalization for mental health/substance use
          </label>
          <v-textarea
            color="white"
            v-model="reg.history"
            outlined
            auto-grow
            :rows="3"
            :counter="8000"
            :maxlength="8000"
            readonly
          />
        </v-col>
      </v-row>
      <h4 class="">Counselor</h4>
      <v-row dense>
        <v-col cols="12" md="6">
          <v-text-field
            color="white"
            dark
            maxlength="60"
            v-model="reg.cnsl_name"
            :counter="60"
            label="Name"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-mask="'###-###-####'"
            color="white"
            dark
            maxlength="12"
            v-model="reg.cnsl_phone"
            :counter="12"
            label="Phone"
            placeholder="###-###-####"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <h4 class="">Psychiatrist</h4>
      <v-row dense>
        <v-col cols="12" md="6">
          <v-text-field
            color="white"
            dark
            maxlength="60"
            v-model="reg.psych_name"
            :counter="60"
            label="Name"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-mask="'###-###-####'"
            color="white"
            dark
            maxlength="12"
            v-model="reg.psych_phone"
            :counter="12"
            label="Phone"
            placeholder="###-###-####"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <!--  General *********************** -->
      <h4 class="mt-5">General</h4>
      <v-row dense>
        <v-col cols="12" md="6">
          <v-text-field
            color="white"
            dark
            maxlength="60"
            v-model="reg.hospital"
            :counter="60"
            label="Preferred Hospital"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-select
            dark
            color="white"
            item-color="white"
            attach
            multiple
            v-model="reg.triggers"
            :items="['Loud Noises', 'Physical Touch', 'Bright Lights']"
            label="Known triggers"
            readonly
            disabled
          ></v-select>
        </v-col>
      </v-row>
      <v-row dense class="mt-3">
        <v-col cols="12" md="12">
          <label>Other Triggers</label>
          <v-textarea
            color="white"
            v-model="reg.triggers_other"
            outlined
            auto-grow
            :rows="3"
            :counter="8000"
            :maxlength="8000"
            readonly
          />
        </v-col>
      </v-row>
      <v-row dense class="mt-3">
        <v-col cols="12" md="12">
          <label>Helpful de-escalation strategies</label>
          <v-textarea
            color="white"
            v-model="reg.de_escalation"
            outlined
            auto-grow
            :rows="3"
            :counter="8000"
            :maxlength="8000"
            readonly
          />
        </v-col>
      </v-row>
      <v-row dense class="mt-3">
        <v-col cols="12" md="12">
          <label>Things to try and avoid with me</label>
          <v-textarea
            color="white"
            v-model="reg.avoid"
            outlined
            auto-grow
            :rows="3"
            :counter="8000"
            :maxlength="8000"
            readonly
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" md="6">
          <v-text-field
            color="white"
            dark
            maxlength="60"
            v-model="reg.toy"
            :counter="60"
            label="Any favorite toy or object"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-select
            dark
            color="white"
            attach
            v-model="reg.response"
            :items="['Call provider', 'Call family', 'Hospital transport']"
            label="Preferred response when in a crisis"
            readonly
            disabled
          ></v-select>
        </v-col>
      </v-row>
      <v-row dense class="mt-3">
        <v-col cols="12" md="12">
          <v-select
            dark
            color="white"
            attach
            v-model="reg.violence"
            :items="['No', 'Yes']"
            :rules="requiredYesNo"
            label="Any history of aggression or violence?"
            required
            readonly
            disabled
          ></v-select>
        </v-col>
      </v-row>

      <v-row dense v-if="reg.violence === 'Yes'">
        <v-col cols="12" md="12">
          <label>If yes, please provide an example</label>
          <v-textarea
            color="white"
            v-model="reg.violence_example"
            outlined
            auto-grow
            :rows="3"
            :counter="8000"
            :maxlength="8000"
            :rules="requiredYesNo"
            required
            readonly
          />
        </v-col>
      </v-row>

      <v-row dense class="mt-3">
        <v-col cols="12" md="12">
          <label> Pets or service animals?</label>
          <v-textarea
            color="white"
            v-model="reg.pets"
            outlined
            auto-grow
            :rows="3"
            :counter="8000"
            :maxlength="8000"
            readonly
          />
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
  </div>
</template>

<style lang="scss" scoped>
label {
  font-weight: 800;
}
output {
  margin-left: 5px;
  font-size: 16px;
}
/* Base: 0px and up (default styles) */
@media (min-width: 0px) {
  .btn-size {
    width: 100%;
  }
}

/* Breakpoint: 768px and up */
@media (min-width: 768px) {
  .btn-size {
    width: auto;
  }
}
</style>

<script>
import { bus_common } from "../mixins/bus_common";

import auth2 from "./auth2.vue";
export default {
  name: "viewone",
  components: { auth2 },
  mixins: [bus_common],
  data: function () {
    return {
      showme: "search",
      valid: true,
      sterm: {
        lname: "",
        address: "",
      },
      srch_results: [],
      reg: {},
              requiredYesNo: [
           (v) => !!v || "Field is required",
        ],
    };
  },
  filters: {
    prepend100(value) {
      return "100" + String(value);
    },
    blankanswer(value) {
      var ans = value;
      if (value == "") {
        ans = "Not Answered";
      }
      return ans;
    },
    spaceAfterComma(value) {
      if (!value) return "";
      // Add a space after every comma (unless there is already one)
      return value.replace(/,(\S)/g, ", $1");
    },
  },
  watch: {},
  computed: {},
  methods: {
    backtoresults() {
      this.showme = "results";
    },
    backtosearch() {
      this.showme = "search";
    },
    view(reg) {
      this.reg = this.mno(reg);
      this.reg.dob = this.format_date_us(this.reg.dob);
      this.showme = "reg";
    },
    search_one() {
      this.show_loader(true);

      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.sterm = this.mno(this.sterm);

      formIn.apiname = "search_one";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.mrbreakpoint("results");
          if (data.length == 0) {
            this.swall_it(
              "Search Status",
              "No results were found. Please try different search criteria.",
              "warning",
              null,
              null
            );
          }

          if (data.length >= 1) {
            self.srch_results = self.mno(data);
            for (let index = 0; index < self.srch_results.length; index++) {
              const reg = self.srch_results[index];
              self.reg.dob = self.format_date_us(self.reg.dob);
            }
            self.showme = "results";
          }
          this.show_loader(false);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error search", msg.msg, "error", null, null);
        });
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>

<style scoped></style>
